/*
 CardWeb

 Karta z regulaminami web
  
 historia: 
  PM 2021-11-05 - start
*/

import * as React from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Card, CardContent, Theme, Typography } from '@material-ui/core';

import ResponsiveImgMaterialUi from 'responsive-img-material-ui';
import { Aplikacja } from '../App';
import HotelPolityka from './webTresc/HotelPolityka';
import HotelWarunki from './webTresc/HotelWarunki';

interface CardWebProps {
    regulaminy: string,
    aplikacja: Aplikacja
}

class CardWeb extends React.Component<CardWebProps & WithStyles<typeof styles>> {

    selectComponent = () => {
        switch (this.props.regulaminy) {
            case 'vscHotelBook': return this.selectComponentVscHotelBook()
        }
    }

    selectComponentVscHotelBook = () => {
        switch (this.props.aplikacja.value) {
            case 'Polityka': return <HotelPolityka />
            case 'Warunki': return <HotelWarunki />
        }
    }

    render() {
        const { classes } = this.props;

        return (
            <Card elevation={0} className={classes.card}>
                {window.innerWidth > 600 ? null :
                    (
                        <ResponsiveImgMaterialUi
                            style={{ height: "34px", width: "150px", display: 'block', margin: '0 auto', paddingBottom: '15px' }}
                            xs={require('./logo_virtual.png').default}
                            md={require('./logo_virtual.png').default}
                            lg={require('./logo_virtual.png').default}
                        />
                    )}
                <div>
                    <div style={{ width: window.innerWidth > 600 ? '66.66667%' : '100%' }} className={classes.inlineBlock}>
                        <Typography gutterBottom component="h1" variant="h6">
                            <b >{`${this.props.regulaminy}${this.props.aplikacja.value !== 'Standard' ? ' - ' + this.props.aplikacja.text : ''}`}</b>
                        </Typography>
                    </div>
                    {window.innerWidth > 600 ?
                        (
                            <span style={{ float: "right", paddingRight: "5px" }} className={classes.inlineBlock}>
                                <ResponsiveImgMaterialUi style={{ height: "100%", width: "100%" }}
                                    xs={require('./logo_virtual.png').default}
                                    md={require('./logo_virtual.png').default}
                                    lg={require('./logo_virtual.png').default}
                                />
                            </span>
                        ) : null}
                </div>
                <hr style={{ border: "0", borderBottom: "1px solid rgb(224, 224, 224)" }} />
                <CardContent>
                    {this.selectComponent()}
                </CardContent>
            </Card>
        );
    }
}

const styles = (theme: Theme) => ({
    inlineBlock: {
        display: 'inline-block'
    },
    card: {
        paddingTop: theme.spacing(6)
    },
});

export default withStyles(styles)(CardWeb);
